<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable
                        @change="handleStoreChange">
                        <el-option v-for="item in storeList" :key="item.keyId" :label="item.value"
                            :value="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="编号：">
                    <el-input v-model="formInline.code" placeholder="请输入申购单编号" clearable size="small"></el-input>
                </el-form-item>
                <el-form-item label="申请时间：">
                    <el-date-picker clearable v-model="dateRange" size="small" type="daterange"
                        value-format="yyyy-MM-dd" format="yyyy年MM月dd日" @change="handleDateChange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="状态：">
                    <el-select v-model="formInline.state" placeholder="请选择状态" clearable size="small" @change="search">
                        <el-option v-for="item in stateList" :key="item.code" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="btnPermission.search" size="small" type="primary" class="el-icon-search"
                        @click="inputChange()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
            <STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId">
                <el-table-column slot="mainInfo.code" label="申购单编号" min-width="220" align="center">
                    <template slot-scope="scope">
                        <el-link type="primary" :underline="false" @click="handleDetailClick(scope.row)">
                            {{ scope.row.mainInfo.code }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column slot="stateStr" label="申购状态" min-width="120" align="center" fixed="left">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.mainInfo.state == 1">{{ scope.row.mainInfo.stateStr
                            }}</el-tag>
                        <el-tag type="primary" v-else-if="scope.row.mainInfo.state == 2">{{ scope.row.mainInfo.stateStr
                            }}</el-tag>
                        <el-tag type="danger" v-else-if="scope.row.mainInfo.state == 8">{{ scope.row.mainInfo.stateStr
                            }}</el-tag>
                        <el-tag type="info" v-else-if="scope.row.mainInfo.state == 3">{{ scope.row.mainInfo.stateStr
                            }}</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.mainInfo.state == 4">{{ scope.row.mainInfo.stateStr
                            }}</el-tag>
                        <el-tag type="warning" v-else-if="scope.row.mainInfo.state == 5">{{ scope.row.mainInfo.stateStr
                            }}</el-tag>
                        <el-tag type="primary" v-else-if="scope.row.mainInfo.state == 6">{{ scope.row.mainInfo.stateStr
                            }}</el-tag>
                        <el-tag type="success" v-else>{{ scope.row.mainInfo.stateStr }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column slot="moneyTotal" label="小计" min-width="100" align="center">
                    <template slot-scope="scope">
                        ￥{{ scope.row.quantity * scope.row.costMoney + scope.row.shippingCost }}元
                    </template>
                </el-table-column>
                <el-table-column slot="operation" label="操作" min-width="170" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.mainInfo.state == 4 && !scope.row.payDate && btnPermission.pay"
                            size="mini" icon="el-icon-finished" type="primary"
                            @click="handleConfirmPayClick(scope.row)">
                            付款
                        </el-button>
                        <el-button
                            v-if="!scope.row.kdNo && btnPermission.kuaidi && scope.row.mainInfo.state > 4 && scope.row.mainInfo.state < 7"
                            icon="el-icon-s-promotion" size="mini" type="warning" @click="handleKuaiDiClick(scope.row)">
                            发快递
                        </el-button>
                    </template>
                </el-table-column>
            </STable>
            <!-- 分页组件 -->
            <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </topTab>
        <!-- 详情 -->
        <detail ref="detail" :storeList="storeList"></detail>

        <!-- 录入快递单号 -->
        <el-dialog :visible.sync="dialogEditKDNoVisible" title="录入快递单号" style="width: 60%; margin: auto"
            :close-on-click-modal="false">
            <span style="display: block; margin-bottom: 10px"><strong>快递单号:</strong></span>
            <el-input v-model="editKDInfo.kdNo" placeholder="请输入快递单号" maxlength="30" show-word-limit></el-input>
            <span slot="footer">
                <el-button @click="dialogEditKDNoVisible = false" size="small">取消</el-button>
                <el-button type="primary" size="small" @click="handleEditKDNoClick">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    GetStoreSubscriptionDtlPageList,
    KuaiDiStoreSubScriptionDtl,
    PayStoreSubScriptionDtl
} from "@/api/productApi.js";
import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detail from '@/views/product/subscription/detail.vue'
export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "申购单明细",
                },
            ],
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
            formInline: {
                pageIndex: 1,
                pageSize: 10,
                storeKeyId: "",
                state: 0,
                code: "",
                startTime: null,
                endTime: null,
            },
            columnsData: [],
            listColumns: [
                {
                    prop: "rowNumber",
                    label: "序号",
                    align: "center",
                    fixed: "left",
                    width: "80",
                    isKeep: true,
                },
                {
                    prop: "createTime",
                    label: "申购时间",
                    width: "170",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "creator",
                    label: "申购人",
                    width: "120",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "mainInfo.storeName",
                    label: "所属门店",
                    width: "120",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "productTypeInfo.typeName",
                    label: "类型",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "productTypeInfo.productName",
                    label: "系列",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "productTypeInfo.specification",
                    label: "商品名称",
                    width: "220",
                    align: "center",
                },
                {
                    prop: "quantity",
                    label: "申购数量",
                    width: "100",
                    align: "center",
                },
                {
                    prop: "realQty",
                    label: "实际数量",
                    width: "100",
                    align: "center",
                },
                {
                    prop: "productTypeInfo.unit",
                    label: "单位",
                    width: "80",
                    align: "center",
                },
                {
                    prop: "costMoney",
                    label: "成本价",
                    width: "80",
                    align: "center",
                },
                {
                    prop: "shippingCost",
                    label: "运费",
                    width: "80",
                    align: "center",
                },
                {
                    slot: "moneyTotal",
                    label: "小计",
                    width: "100",
                    align: "center",
                },
                {
                    prop: "supplyName",
                    label: "付款对象",
                    width: "140",
                    align: "center",
                },
                {
                    slot: "stateStr",
                    label: "申购状态",
                    width: "120",
                    align: "center",
                    fixed: "left",
                },
                {
                    prop: "kdNo",
                    label: "快递单号",
                    width: "180",
                    align: "center",
                },
                {
                    slot: "mainInfo.code",
                    label: "申购单号",
                    isKeep: true,
                    minWidth: "170",
                    align: "center",
                },
                {
                    prop: "payUserName",
                    label: "支付人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "payDate",
                    label: "支付时间",
                    width: "180",
                    align: "center",
                },
                {
                    prop: "receiveUserName",
                    label: "接收人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "receiveDate",
                    label: "接收时间",
                    width: "180",
                    align: "center",
                },
                {
                    prop: "remark",
                    label: "备注",
                    width: "220",
                    align: "center",
                },
                {
                    prop: "editor",
                    label: "维护人",
                    width: "120",
                    align: "center",
                },
                {
                    prop: "updateTime",
                    label: "维护时间",
                    width: "170",
                    align: "center",
                },
                {
                    slot: "operation",
                    label: "操作",
                    width: "170",
                    align: "center",
                },
            ],
            storeList: [],
            stateList: [],
            dateRange: [],
            btnPermission: {
                search: false,
                pay: false,
                kuaidi: false,
            },
            // 录入快递单号
            editKDInfo: {
                kdNo: '',
                keyId: ''
            },
            dialogEditKDNoVisible: false,
        };
    },
    // 注册组件
    components: {
        detail,
    },
    created() {
        // 初始列
        this.getCheckBox(this.listColumns.map((item) => item.label));
        this.GetOrgInfoListByConfig();
        this.GetEnumConfigListByCode();
        this.getListData();
        // 按钮权限
        this.btnPermission = {
            search: this.$checkBtnPermission('/subscriptionDtl/main', 'viewPage'),
            pay: this.$checkBtnPermission('/subscriptionDtl/main', 'pay'),
            kuaidi: this.$checkBtnPermission('/subscriptionDtl/main', 'kuaidi'),
        }
    },
    computed: {},
    methods: {
        // 获取筛选框
        getCheckBox(val) {
            let arr = this.listColumns.filter((v) => !val.includes(v.label));
            this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
        },
        changePages() { },
        // 获取列表
        getListData() {
            this.loading = true;
            GetStoreSubscriptionDtlPageList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                        this.pageparm.total = res.totalNumber;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        inputChange() {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        //获取状态信息
        GetEnumConfigListByCode() {
            const paramer = {
                code: "StoreSubscriptionState",
            };
            GetEnumConfigListByCode(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.stateList = [];
                        res.data.forEach((item) => {
                            this.stateList.push({
                                code: parseInt(item.code),
                                name: item.name,
                            });
                        });
                        this.stateList.unshift({
                            code: 0,
                            name: "全部",
                        });
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取状态信息失败!");
                });
        },
        handleDateChange(val) {
            if (val) {
                this.formInline.startTime = val[0];
                this.formInline.endTime = val[1];
            } else {
                this.formInline.startTime = null;
                this.formInline.endTime = null;
            }
            this.search();
        },
        // 门店选择事件
        handleStoreChange(val) {
            this.formInline.storeKeyId = val;
            this.search();
        },
        // 详情
        handleDetailClick(row) {
            this.$refs.detail.showDetail(row.mainInfo.keyId, 1);
        },
        // 付款
        handleConfirmPayClick(row) {
            this.$confirm("确认付款【" + row.mainInfo.storeName + "】【" + row.productTypeInfo.specification + "】吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                PayStoreSubScriptionDtl({
                    keyId: row.keyId,
                }).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "付款成功！",
                        });
                        this.search();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                });
            });
        },
        // 发快递
        handleKuaiDiClick(row) {
            this.editKDInfo.keyId = row.keyId;
            this.editKDInfo.kdNo = '';
            this.dialogEditKDNoVisible = true;
        },
        // 录入快递单号
        handleEditKDNoClick() {
            if (!this.editKDInfo.kdNo) {
                this.$message.error("请输入快递单号");
                return;
            }
            this.$confirm("确认录入快递单号【" + this.editKDInfo.kdNo + "】吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                KuaiDiStoreSubScriptionDtl({
                    keyId: this.editKDInfo.keyId,
                    kdNo: this.editKDInfo.kdNo,
                }).then((res) => {
                    if (res.code == 1) {
                        this.$message({
                            type: "success",
                            message: "录入成功！",
                        });
                        this.dialogEditKDNoVisible = false;
                        this.search();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                });
            });
        },

    },
};
</script>

<style scoped></style>